// extracted by mini-css-extract-plugin
module.exports = {"button":"ToTopButton_button__HMPzp","visible":"ToTopButton_visible___HZDZ","slide-in-out":"ToTopButton_slide-in-out__eD4St","fade-in-out":"ToTopButton_fade-in-out__jq0bO"};